import { authApi } from '@/api';
import hubStorage from '@/helpers/hubStorage';
export default {
    async getAccessToken({ username = '', password = '' }) {
        const data = new URLSearchParams({
            username,
            password,
            grant_type: 'password',
            client_id: process.env.VUE_APP_CLIENT_ID,
            client_secret: process.env.VUE_APP_CLIENT_SECRET,
            accountType: 'HUB',
        });
        const response = await authApi.getAccessToken(data);
        const accessToken = response.data.access_token;
        hubStorage.setAccessToken(accessToken);
        return accessToken;
    },
    async refreshToken() {
        const data = new URLSearchParams({
            refresh_token: '',
            grant_type: 'refresh_token',
            client_id: process.env.VUE_APP_CLIENT_ID,
            client_secret: process.env.VUE_APP_CLIENT_SECRET,
        });
        const response = await authApi.refreshAccessToken(data);
        const accessToken = response.data.access_token;
        hubStorage.setAccessToken(accessToken);
        return accessToken;
    },
    removeAccessToken() {
        hubStorage.removeAccessToken();
    },
};
